import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/internal/Observable';
import { tap, switchMap, map } from 'rxjs/operators';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(
    public oidcSecurityService: OidcSecurityService,
    private cookieService: CookieService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const cookieToken = this.cookieService.get('newToken');

    if (cookieToken) {
      // If we have a token in cookies, use it directly
      const apiReq = this.createRequestWithToken(request, cookieToken);
      return next.handle(apiReq).pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.status === 401) {
              this.oidcSecurityService.logoff();
            }
            this.setUserDetails(event);
          }
        })
      );
    } else {
      // If no cookie token, get it from OIDC service (Observable)
      return this.oidcSecurityService.getAccessToken().pipe(
        switchMap((token: string) => {
          const apiReq = this.createRequestWithToken(request, token);
          return next.handle(apiReq);
        }),
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.status === 401) {
              this.oidcSecurityService.logoff();
            }
            this.setUserDetails(event);
          }
        })
      );
    }
  }

  private createRequestWithToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    const authToken = 'Bearer ' + token;

    return request.clone({
      url: request.url,
      setHeaders: {
        Authorization: authToken ? authToken : '',
        'Access-Control-Allow-Origin': '*',
        userid: this.cookieService.get('userId'),
        businessid: this.cookieService.get('businessid'),
      },
    });
  }

  setUserDetails(event): void {
    const userId = event.headers.get('userid');
    const businessId = event.headers.get('businessid')!;
    const authorizedRole = event.headers.get('authorizedRole')!;
    const themecolor = event.headers.get('themecolor')!;

    this.cookieService.set('isLoggedin', !!userId ? 'true' : 'false');
    const isAdmin = authorizedRole !== '4' ? 'true' : 'false';
    const isOwner = authorizedRole === '1' ? 'true' : 'false';
    const isRegularUser = authorizedRole === '4' ? 'true' : 'false';
    const isManager = authorizedRole === '3' ? 'true' : 'false';
    if (!!userId) {
      this.cookieService.set('authorizedRole', authorizedRole);
      this.cookieService.set('userId', userId);
      this.cookieService.set('isAdmin', isAdmin);
      this.cookieService.set('isOwner', isOwner);
      this.cookieService.set('isRegularUser', isRegularUser);
      this.cookieService.set('isManager', isManager);
    }
    if (!!businessId) {
      this.cookieService.set('businessid', businessId);
    }
    if (!!themecolor) {
      this.cookieService.set('themecolor', themecolor);
    }
  }
}
